import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "popover"]

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()

    const expanded = this.buttonTarget.getAttribute("aria-expanded") === "true"
    this.setExpanded(!expanded)
  }

  close() {
    this.setExpanded(false)
  }

  closeOnOutsideClick(event) {
    if (this.element.contains(event.target)) {
      return
    }

    this.close()
  }

  setExpanded(expanded) {
    if (!this.hasButtonTarget || !this.hasPopoverTarget) {
      return
    }

    this.buttonTarget.setAttribute("aria-expanded", String(expanded))
    this.popoverTarget.classList.toggle("is-hidden", !expanded)
  }
}
